var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "express-list" },
    [
      _c(
        "van-tabs",
        {
          attrs: { "line-width": 50 },
          on: { click: _vm.tabClicked },
          model: {
            value: _vm.selectIndex,
            callback: function($$v) {
              _vm.selectIndex = $$v
            },
            expression: "selectIndex"
          }
        },
        _vm._l(_vm.navList, function(item, index) {
          return _c(
            "van-tab",
            { key: index, attrs: { title: item.text, name: index } },
            [
              _c(
                "van-pull-refresh",
                {
                  on: { refresh: _vm.onRefresh },
                  model: {
                    value: _vm.isLoading,
                    callback: function($$v) {
                      _vm.isLoading = $$v
                    },
                    expression: "isLoading"
                  }
                },
                [
                  _c("div", { staticClass: "yudan-number" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.logisticsCompany) +
                          "：" +
                          _vm._s(_vm.logisticsCode)
                      )
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:copy",
                          value: _vm.logisticsCode,
                          expression: "logisticsCode",
                          arg: "copy"
                        },
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:success",
                          value: _vm.onCopy,
                          expression: "onCopy",
                          arg: "success"
                        },
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:error",
                          value: _vm.onError,
                          expression: "onError",
                          arg: "error"
                        }
                      ],
                      staticClass: "clip-icon",
                      attrs: {
                        src: require("../assets/img/common/copy@2x.png")
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "step-list" },
                    [
                      _c(
                        "van-steps",
                        {
                          attrs: {
                            direction: "vertical",
                            active: _vm.activeCount
                          }
                        },
                        _vm._l(_vm.stepInfoList, function(item, index) {
                          return _c("van-step", { key: index }, [
                            _c("h3", [_vm._v(_vm._s(item.title))]),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(item.desc))])
                          ])
                        }),
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }